import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { BookmarkSimple } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

// Toggle button to save/unsave an institution to the logged-in user's profile.
export default function SaveInstitutionButton({ instId, saved, onToggle, size = "sm", variant = "outline", className = "", stopPropagation = true }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);

  const click = async (e) => {
    if (stopPropagation) { e.preventDefault(); e.stopPropagation(); }
    if (!user) { toast.info("Sign in to save institutions to your profile"); nav("/login"); return; }
    setBusy(true);
    try {
      if (saved) { await api.delete(`/profiles/me/saved-institutions/${instId}`); toast.success("Removed from your profile"); }
      else { await api.post("/profiles/me/saved-institutions", { institution_id: instId }); toast.success("Saved to your profile"); }
      onToggle && onToggle(instId, !saved);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Could not update"); }
    finally { setBusy(false); }
  };

  return (
    <Button
      size={size}
      variant={saved ? "secondary" : variant}
      className={`rounded-full gap-1.5 ${className}`}
      onClick={click}
      disabled={busy}
      data-testid={`save-institution-${instId}`}
    >
      <BookmarkSimple size={15} weight={saved ? "fill" : "regular"} /> {saved ? "Saved" : "Save"}
    </Button>
  );
}
